import {UI} from "../../../../stem-core/src/ui/UIBase.js";
import {BasePanelPage} from "../panels/BasePanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {MerchantButton} from "../../../common/MerchantButton";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {Flow} from "../../initializeFlows";

export class ProductPanel extends UI.Element {
    render() {
        const {product} = this.options;
        return [
            <h1>{product.name}</h1>,
            <MessageElement message={product.description} />,
            <div>Price: {product.getAmount()}</div>,
            product.requiresAddress && <div>Address Required</div>,
            <MerchantButton
                label={Messages.shopBuyNow}
                onClick={() => Flow.shop.selectProduct(product)}
            />,
            <hr/>
        ]
    }
}

export class ShopPanel extends BasePanelPage {
    render() {
        const products = iFrameState.getProducts();
        if (products.length === 0) {
            return ["No products available"];
        }
        return products.map(product => <ProductPanel product={product} />);
    }
}
